const ja = {
    '/': {
        title: '{brand} | スポーツベット、ライブカジノ、即時出金',
        description: '{brand}とブックメーカーを一つのウォレットで。スロット、ライブカジノ、プロバブリーフェアのオリジナルゲームとスポーツベッティング、仮想通貨は即時出金。',
        keywords: '仮想通貨カジノ, ビットコインカジノ, 仮想通貨ブックメーカー, オンラインスロット, 即時出金, プロバブリーフェア'
    },
    '/casino': {
        title: '{brand} オンラインカジノ | スロット & ライブディーラー',
        description: '{brand}でスロット、ブラックジャック、ルーレット & ライブディーラーを楽しめます。数百のゲーム、高速クリプト入金 & 24時間いつでも即時出金。',
        keywords: '仮想通貨カジノ, ビットコインカジノ, オンラインカジノ, 仮想通貨スロット, ライブカジノ, ブラックジャック, ルーレット'
    },
    '/sports': {
        title: '{brand} スポーツベッティング | ライブベット & 高オッズ',
        description: '{brand}でスポーツに賭けましょう。サッカー、バスケットボールなどの競争力あるオッズ。ライブベッティング、安全なクリプト賭け & 迅速な支払い。',
        keywords: '仮想通貨ブックメーカー, ビットコインスポーツベット, ライブベット, サッカーオッズ, eスポーツベット'
    },
    '/livecasino': {
        title: '{brand} ライブカジノ | ブラックジャック & ルーレット',
        description: '{brand}でブラックジャック、ルーレット & ライブカジノゲームを楽しめます。本物のディーラー、HDストリーミング & 24時間豊富なライブテーブル。',
        keywords: 'ライブカジノ, ライブディーラー, ライブブラックジャック, ライブルーレット, ライブバカラ, ゲームショー'
    },
    '/slots': {
        title: '{brand} オンラインスロット | 豊富なカジノスロット',
        description: '{brand}で膨大なスロットコレクションを回しましょう。クラシックフルーツマシン、ビデオスロット & プログレッシブ - すべてクリプトでプレイ可能。',
        keywords: '仮想通貨スロット, ビットコインスロット, オンラインスロット, ビデオスロット, メガウェイズ, ボーナス購入'
    },
    '/vip': {
        title: '{brand} VIPプログラム | 限定リワード & 特典',
        description: '{brand}のVIPプログラム：限定ボーナス、パーソナライズ特典、優先サポート。アクティブなプレイヤー向けの特別な恩恵。',
        keywords: 'カジノVIPプログラム, レーキバック, ロイヤリティ特典, ハイローラーカジノ, VIPランク'
    },
    '/welcome-offer': {
        title: '{brand} ウェルカムオファー | クリプトカジノ',
        description: '{brand}のウェルカムオファーをご確認ください。クリプトで始めて、新規プレイヤー限定の特典をお楽しみください。',
        keywords: 'カジノ入金ボーナス, 仮想通貨カジノボーナス, 初回入金ボーナス, 新規プレイヤー特典'
    },
    '/referral': {
        title: '{brand} 紹介プログラム | リワードを獲得',
        description: '友達を{brand}に招待して、参加・条件達成時にリワードを獲得しましょう。紹介リンクをシェアして稼ぎ始めよう。',
        keywords: 'カジノ紹介プログラム, 友達紹介ボーナス, アフィリエイト報酬'
    },
    '/promotion-page': {
        title: '{brand} プロモーション | ボーナス & 特別オファー',
        description: '{brand}の全プロモーションをご覧ください。クリプトプレイヤー向けのボーナス、フリースピン、特別オファー。',
        keywords: 'カジノプロモーション, 仮想通貨カジノボーナス, ウィークリーレース, カジノトーナメント'
    },
    '/hotslots': {
        title: '{brand} 人気スロット | 話題のカジノスロット',
        description: '{brand}で最も人気のスロットゲームをプレイ。ホットなスロットをクリプトで楽しもう。'
    },
    '/newgames': {
        title: '{brand} 新着ゲーム | 最新カジノゲーム',
        description: '{brand}で最新のカジノゲームをチェック。スロット、ライブゲーム、テーブルゲームの新作が続々登場。'
    },
    '/populargames': {
        title: '{brand} 人気ゲーム | 人気カジノゲーム',
        description: '{brand}で最も人気の高いカジノゲームをお楽しみください。スロットからライブゲームまで幅広くご用意。'
    },
    '/gameshows': {
        title: '{brand} ゲームショー | ライブゲームショーカジノ',
        description: '{brand}でライブゲームショーをお楽しみください。本物の司会者とユニークなゲームで大勝ちを目指そう。'
    },
    '/table_games': {
        title: '{brand} テーブルゲーム | ブラックジャック、ルーレット & バカラ',
        description: '{brand}でブラックジャック、ルーレット、バカラなどのテーブルゲームをお楽しみください。クリプトでプレイ可能。'
    },
    '/hotlive': {
        title: '{brand} 人気ライブカジノ | 注目のライブカジノゲーム',
        description: '{brand}で最も人気の高いライブカジノゲームをお楽しみください。本物のディーラーとリアルタイムで対戦。'
    },
    '/featurebuyin': {
        title: '{brand} ボーナス購入スロット | フィーチャーバイイン',
        description: '{brand}でボーナス購入機能付きスロットをプレイ。待たずにボーナスラウンドへ直接アクセス。'
    },
    '/originals': {
        title: '{brand} オリジナルカジノゲーム | 限定タイトル',
        description: '{brand}で独自開発の限定オリジナルゲームをプレイ。他では遊べないユニークなタイトルで、比類なきカジノ体験をお届けします。'
    },
    '/providers': {
        title: '{brand} ゲームプロバイダー | 提携スタジオ & ソフトウェア',
        description: '{brand}の全ゲームプロバイダーをチェック。トップスタジオと提携し、多彩で高品質なクリプトカジノライブラリをご提供しています。'
    },
    '/about-us': {
        title: '私たちについて | {brand}をもっと知る',
        description: 'クリプトカジノ & スポーツブックのリーディングブランド{brand}について詳しく知る。安全、公正、スリリングなギャンブルと即時クリプト出金へのこだわりをご紹介。'
    },
    '/affiliate': {
        title: 'アフィリエイトプログラム | {brand}でクリプトを稼ごう',
        description: '{brand}のパートナーとなり、クリプトカジノのプロモーションで報酬を獲得。競争力のあるレート、リアルタイム追跡、専任アフィリエイトサポートをご提供。'
    },
    '/faq': {
        title: '{brand} よくある質問 | FAQ',
        description: '{brand}に関するよくある質問の回答を探す。アカウント、支払い、ボーナス & カジノゲームについてFAQをご参照ください。'
    },
    '/aml-policy': {
        title: 'AMLポリシー | {brand}のマネーロンダリング防止対策',
        description: '{brand}のAMLポリシーは安全で信頼性の高い環境を保証します。プラットフォーム上の不正行為防止対策についてご確認ください。'
    },
    '/bonus-terms': {
        title: 'ボーナス利用規約 | {brand}のプロモーション',
        description: '{brand}のカジノボーナス & プロモーションの規約をお読みください。ボーナスの取得、使用、ボーナス獲得額の出金方法についてご確認ください。'
    },
    '/complaints-and-arbitration': {
        title: '苦情と仲裁 | {brand}のプレイヤーサポート',
        description: '{brand}の苦情・紛争解決プロセスをご確認ください。公正な取り扱いを保証し、プレイヤーの問題を迅速かつ透明に解決します。'
    },
    '/fairness': {
        title: 'プロバブリーフェアゲーム | {brand}の公正性保証',
        description: '{brand}はプロバブリーフェア技術を使用し、すべてのゲーム結果が検証可能、透明、かつ完全にランダムであることを保証します。'
    },
    '/kyc-policy': {
        title: 'KYCポリシー | {brand}の本人確認',
        description: '{brand}のKYCポリシーでは本人確認プロセスについて説明しています。プレイヤーの保護と安全なゲーミング環境の維持方法をご確認ください。'
    },
    '/payment-policy': {
        title: '{brand} 支払いポリシー | クリプト入出金',
        description: '{brand}はクリプトでの入出金に対応。取引限度額、利用可能なコイン、処理時間については支払いポリシーをお読みください。'
    },
    '/privacy-policy': {
        title: 'プライバシーポリシー | {brand}のデータ保護',
        description: '{brand}のプライバシーポリシー。クリプトカジノプラットフォームにおける個人データの収集、利用、保護方法についてご確認ください。'
    },
    '/responsible-gaming': {
        title: '責任あるギャンブル | {brand}で安全にプレイ',
        description: '{brand}は責任あるギャンブルへの取り組みを重視しています。プレイ習慣を管理し安全に楽しむためのツール & リソースをご利用ください。'
    },
    '/terms-of-service': {
        title: '利用規約 | {brand}',
        description: '{brand}の利用を規定する利用規約をご確認ください。プレイヤーとしての権利と責任について理解を深めてください。'
    },
    '/terms-sports': {
        title: 'スポーツベッティング利用規約 | {brand}',
        description: '{brand}のスポーツベッティング利用規約。ベットの配置、当選払い戻し & プラットフォームでのスポーツブック利用に関するルールをご確認ください。'
    },
    '/special-bets': {
        title: '{brand} スペシャルベット | クリプトスポーツブック',
        description: '{brand}でスペシャルベットを楽しめます。スポーツ、eスポーツ & 単発イベントのマーケット。仮想通貨の入金は即時、出金も高速です。'
    },
    '/transparency': {
        title: '{brand} 透明性 | プロバブリーフェアな仮想通貨カジノ',
        description: '{brand}の運営はすべて公開されています。プロバブリーフェアなゲーム検証、ライブカタログから読み取る還元率の公開 & オンチェーンの出金。'
    },
    '/faq/about': {
        title: '{brand}について | よくある質問',
        description: '{brand}について:ライセンス、仮想通貨カジノの仕組み & プラットフォームの公正性。よくある質問への回答をご覧ください。'
    },
    '/faq/account': {
        title: '{brand} アカウント | よくある質問',
        description: '{brand}のアカウント管理:登録、ログイン、認証 & プロフィール設定。アカウントに関するよくある質問にお答えします。'
    },
    '/faq/bonuses': {
        title: '{brand} ボーナス | よくある質問',
        description: '{brand}のボーナス解説:ウェルカムオファー、プロモコード、賭け条件 & 特典。ボーナスに関するよくある質問にお答えします。'
    },
    '/faq/deposits': {
        title: '{brand} 入金 | よくある質問',
        description: '{brand}への仮想通貨入金方法:対応通貨、ネットワーク、最低額 & 承認時間。入金に関するよくある質問にお答えします。'
    },
    '/faq/games-sports': {
        title: '{brand} ゲーム & スポーツ | よくある質問',
        description: '{brand}のカジノゲーム & スポーツベッティング:プロバイダー、プロバブリーフェア、オッズ & ライブベット。よくある質問にお答えします。'
    },
    '/faq/responsible-gambling': {
        title: '{brand} 責任あるギャンブル | よくある質問',
        description: '{brand}の責任あるギャンブル:入金限度額、自己排除、クールオフ & 安全にプレイするためのサポートツール。'
    },
    '/faq/security': {
        title: '{brand} セキュリティ | よくある質問',
        description: '{brand}のセキュリティ:アカウント保護、二要素認証、公正性 & データプライバシー。よくある質問にお答えします。'
    },
    '/faq/support-disputes': {
        title: '{brand} サポート & 異議申し立て | よくある質問',
        description: '{brand}でのサポート:ライブチャット、応答時間 & 異議申し立ての解決方法。よくある質問にお答えします。'
    },
    '/faq/withdrawals': {
        title: '{brand} 出金 | よくある質問',
        description: '{brand}からの仮想通貨出金方法:支払い時間、最低額、手数料 & 上限。出金に関するよくある質問にお答えします。'
    }
};
export default ja;
